export const common = {
	//Menu
	"menu.play": "Gioca",
	"menu.ranking": "Classifica",
	"menu.prizes": "Premi",
	"menu.rules": "Regole",
	"menu.leagues": "Leghe",
	"menu.betwayAccount": "Account Betway",
	"menu.terms": "T&C",

	//Play
	"play.heroTitle": "Prevedi ogni risultato della partita e vinci premi!",
	"play.heroSubtitle": "Quale squadra vincerà? Quanti gol segneranno? Prevedi ora e sfida i tuoi amici!",
	"play.playNow": "Gioca ora",
	"play.seePrizes": "Vedi i premi",
	"play.statistics": "Statistiche",
	"play.lastMatches": "Ultime 5 partite di ogni squadra",
	"play.stats": "Statistiche",

	//Ranking
	"ranking.season": "Stagione",
	"ranking.weekly": "Settimanale",
	"ranking.selectType": "Seleziona tipo di classifica",
	"ranking.selectWeek": "Seleziona settimana",
	"ranking.myPosition": "La mia posizione",
	"ranking.points": "Punti",
	"ranking.rank": "Posizione",
	"ranking.topMembers": "Top membri",
	"ranking.noRanking": "Nessuna classifica ancora.",
	"ranking.competitionStart":
		"Una volta iniziata la competizione, tutti gli utenti che hanno giocato a BW Fantasy Footballt saranno classificati qui.",
	"ranking.loadMore": "Carica altro",
	"ranking.loading": "Caricamento...",

	//Leagues
	"leagues.heroTitle": "Sfida i tuoi amici o unisciti a leghe pubbliche!",
	"leagues.heroSubtitle": "Chi ha le migliori abilità di previsione? Crea o unisciti a una lega per scoprirlo!",
	"leagues.createLeague": "Crea una lega",
	"leagues.joinLeague": "Unisciti a una lega",
	"leagues.createLeagueButton": "Crea lega",
	"leagues.joinLeagueButton": "Unisciti alla lega",
	"leagues.enterName": "Inserisci nome della lega",
	"leagues.enterCode": "Inserisci codice di invito",
	"leagues.myLeagues": "Le mie leghe",
	"leagues.member": "membro",
	"leagues.members": "membri",
	"leagues.membersCapital": "Membri",
	"leagues.league": "Lega",
	"leagues.shareCodeText": "I tuoi amici possono unirsi alla tua lega usando questo codice:",
	"leagues.shareCode": "Condividi codice",
	"leagues.editLeague": "Modifica lega",
	"leagues.delete": "Elimina",
	"leagues.leave": "Abbandona",
	"leagues.deleteWarning": "Tutta la cronologia e i membri saranno eliminati permanentemente.",
	"leagues.leaveWarning": "I tuoi punti di previsione e la classifica saranno eliminati.",
	"leagues.confirmDelete": "Sì, elimina",
	"leagues.confirmLeave": "Sì, abbandona",
	"leagues.cancel": "Annulla",
	"leagues.ban": "Banna",
	"leagues.edit": "Modifica",
	"leagues.save": "Salva",

	//Errors
	"errors.savingPredictions": "Errore nel salvare le previsioni",

	//Predictions
	"predictions.successModal.title": "Previsioni confermate!",
	"predictions.successModal.subtitle": "Le tue previsioni sono state salvate con successo!",
	"predictions.successModal.close": "Chiudi",
	"predictions.seasonEnd.title": "Stagione completata!",
	"predictions.seasonEnd.message":
		"È finita questa stagione di BW Fantasy Football — ottimo lavoro! Congratulazioni al nostro vincitore del gran premio, [username], che ha vinto un viaggio per due per vedere l'Arsenal dal vivo all'Emirates Stadium. Mentre l'azione fa una breve pausa, ci stiamo già preparando per il prossimo round. Resta sintonizzato per gli aggiornamenti e preparati a tornare con previsioni ancora più precise.",
	"predictions.seasonEnd.subtitle": "Non vediamo l'ora di averti di nuovo nel gioco!",
	"predictions.seasonEnd.myPosition": "La mia posizione",
	"predictions.seasonEnd.points": "Punti",
	"predictions.seasonEnd.rank": "Posizione",
	"predictions.seasonEnd.topMembers": "Top 10 membri",
	"predictions.countdown.deadline": "Scadenza",
	"predictions.countdown.deadlineMissed": "Scadenza mancata",
	"predictions.countdown.matchweekDeadline": "Scadenza giornata",
	"predictions.countdown.deadlineMissedMessage":
		"Non hai fatto le tue previsioni per questa settimana, quindi non sono stati guadagnati punti - ma c'è sempre la prossima settimana per riprendersi!",
	"predictions.countdown.days": "GIORNI",
	"predictions.countdown.hours": "ORE",
	"predictions.countdown.minutes": "MIN.",
	"predictions.countdown.seconds": "SEC.",
	"predictions.bonusFooter.loadingOdds": "Caricamento quote...",
	"predictions.bonusFooter.draw": "Pareggio",
	"predictions.bonusFooter.unknown": "Sconosciuto",
	"predictions.bonusFooter.oddsToWin": "Quote di vittoria",
	"predictions.roundSelector.previousRound": "Round precedente",
	"predictions.roundSelector.nextRound": "Prossimo round",
	"predictions.points.totalPoints": "Punti totali",
	"predictions.points.currentPosition": "Posizione attuale",
	"predictions.points.points": "Punti",
	"predictions.points.totalPointsLabel": "Punti totali",
	"predictions.submitButton.submitting": "Invio in corso...",
	"predictions.submitButton.predictionsSaved": "Previsioni salvate",
	"predictions.submitButton.updatePredictions": "Aggiorna previsioni",
	"predictions.submitButton.submitAllPredictions": "Invia tutte le previsioni",
	"predictions.predictionCard.result": "Risultato",
	"predictions.predictionCard.pts": "Pti",

	//Common Components
	"common.shareCard.title": "Invita i tuoi amici a giocare",
	"common.shareCard.description":
		"Invita i tuoi amici a giocare a BW Fantasy Football per vedere chi di voi è il miglior manager di calcio, e per avere tutti la possibilità di vincere premi settimanali!",
	"common.shareCard.button": "Invita amici",
	"common.shareCard.shareTitle": "Scarica BetwayScores",
	"common.shareCard.shareBody": "Scarica BetwayScores e sfida i tuoi amici in BW Fantasy Football!",

	"common.accessDenied.title": "Scarica l'app Betway Scores",
	"common.accessDenied.description":
		"Per accedere a questo contenuto, scarica l'applicazione Betway Scores. Ottieni gli ultimi punteggi, previsioni e funzionalità esclusive a portata di mano.",
	"common.accessDenied.rulesText": "Disponibile per dispositivi iOS e Android. Scarica ora per iniziare!",
	"common.accessDenied.button": "Scarica l'app Betway Scores",

	"common.prizesInfoCard.title": "Informazioni sui premi",
	"common.prizesInfoCard.description1":
		"Non hai bisogno di avere un account Betway per giocare a BW Fantasy Football, tuttavia per riscattare un premio settimanale finendo nella Top 10 di una settimana, devi avere un account Betway per far depositare quelle vincite.",
	"common.prizesInfoCard.description2": "Vedi le Regole e T&C del gioco per i dettagli dei premi settimanali e complessivi.",
	"common.prizesInfoCard.button": "Vedi regole",

	//Prizes Fragment
	"prizes.prizeCard1.title": "Gran Premio – Guarda l'Arsenal all'Emirates Stadium",
	"prizes.prizeCard1.description":
		"Vinci un viaggio per due per vedere l'Arsenal giocare all'Emirates Stadium a Londra, inclusi voli (se necessario), alloggio (se necessario) e £500 di spese.",
	"prizes.prizeCard2.title": "Vincitore del round – Premio in denaro nel tuo account Betway",
	"prizes.prizeCard2.description":
		"Il miglior performer ogni settimana vincerà €150 (o equivalente in valuta – vedi sezione 'Regole') come denaro depositato nel suo account Betway.",
	"prizes.prizeCard3.title": "Posti 2-10 ogni round – Premio in denaro nel tuo account Betway",
	"prizes.prizeCard3.description":
		"Coloro che finiscono dal 2° al 10° posto ogni settimana riceveranno anche premi in denaro nel loro account Betway. Vedi la sezione 'Regole' per gli importi esatti che puoi vincere.",

	"common.modal.pointsFormat": "+{points}pti",

	//Betway Account Fragment
	"betwayAccount.title": "Apri un account Betway",
	"betwayAccount.description":
		"Non hai bisogno di avere un account Betway per giocare a BW Fantasy Football, tuttavia per riscattare un premio settimanale finendo nella Top 10 di una settimana, devi avere un account Betway per far depositare quelle vincite.",
	"betwayAccount.rulesText": "Vedi le Regole e T&C del gioco per i dettagli dei premi settimanali e complessivi.",
	"betwayAccount.button": "Apri un account Betway",
};
